// FormItems.tsx
import React from "react";
import {DateField, Form, Input, InputNumber, Select} from "@pankod/refine-antd";
import {BUNDLE_STATUSES} from "../../../constants";

export const NameFormItem: React.FC = () => (
    <Form.Item label="Title" name="title" rules={[{required: true, message: "Title is required"}]}>
        <Input />
    </Form.Item>
);

export const CodeFormItem: React.FC = () => (
    <Form.Item
        label="Flat Price"
        name="flat_price"
        rules={[{required: true, message: "Flat price is required"}]}
    >
        <InputNumber prefix="$" step="0.01" min={0} style={{width: "100%"}} />
    </Form.Item>
);

export const StatusFormItem: React.FC = () => (
    <Form.Item label="Status" name="status" rules={[{required: true, message: "Status is required"}]}>
        <Select options={BUNDLE_STATUSES} />
    </Form.Item>
);

export const SlugFormItem: React.FC = () => (
    <Form.Item
        label="Slug"
        name="slug"
        tooltip="URL path for the bundle page. Leave blank to auto-generate from the title, e.g. red-wine-starter-pack"
    >
        <Input placeholder="Auto-generated from title" />
    </Form.Item>
);

export const DescriptionFormItem: React.FC = () => (
    <Form.Item label="Description" name="description">
        <Input.TextArea rows={4} placeholder="Bundle description shown on the product page" />
    </Form.Item>
);

export const TagTypeFormItem = ({ selectProps }) => (
    <Form.Item label="Tag Type" name={["tagType", "id"]}>
        <Select {...selectProps} maxTagTextLength={100} />
    </Form.Item>
);

export const CreatedAtFormItem: React.FC = () => (
    <Form.Item label="Created At" name="created_at">
        <DateField format="LLL" value="created_at" />
    </Form.Item>
);

export const UpdatedAtFormItem: React.FC = () => (
    <Form.Item label="Updated At" name="updated_at">
        <DateField format="LLL" value="updated_at" />
    </Form.Item>
);
